import Page from '../components/Page';
import { AppView } from '../constants';

export const NotFound = () => {
  return (
    <Page pageName={AppView.NotFound}>
      <h1>Not Found</h1>
    </Page>
  );
};
